export default __webpack_public_path__ + "2244ee494382d07c2c24da3fbdbc6825.jpeg";